import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from "@angular/core";
import { Store } from "@ngrx/store";
import { OnboardingState } from "../../../store/state/onboarding.state";
import { MatDialog } from "@angular/material/dialog";
import { FileViewerComponent } from "app/shared/components/file-viewer/file-viewer.component";
import { ContextVerbiage, OnboardingVerbiage } from "app/profile/models/supplier.model";
import * as MasterDataSelectors from "../../../store/selectors/masterdata.selector";
import * as MasterDataActions from "../../../store/actions/masterdata.action";
import { Router } from "@angular/router";

@Component({
    selector: 'tsl-onboarding-training',
    templateUrl: './onboarding-training.component.html',
    styleUrls: ['./onboarding-training.component.scss']
})
export class OnboardingTrainingComponent implements OnInit {

    @Input('tsl-onboardingType') onboardingType: 'extended' | 'initial' | 'reactivation' | 'entityExtension' | 'nameOrTINChange';
    @Input('tsl-entityCountry') entityCountry: null;
    @Input('isHomePage') isHomePage: boolean = false;
    @Input('supplierCode') supplierCode: string;
    contextVerbiage: ContextVerbiage;
    isShowFAQ = false;
    isShowManual = false;
    onboardingTypeMap = {
        extended: 'Extended',
        initial: 'Initial',
        Extended: 'Extended',
        Initial: 'Initial',
    }
    verb: OnboardingVerbiage[];

    constructor(
        private onboardingStore: Store<OnboardingState>,
        private matDialog: MatDialog,
    ) {
    }

    ngOnInit(): void {
        this.onboardingStore.dispatch(new MasterDataActions.GetContextVerbiage());
        this.onboardingStore.select(MasterDataSelectors.SelectContextVerbiage).subscribe(contextVerbiage => {
            this.verb = contextVerbiage?.onboardingType[this.onboardingTypeMap[this.onboardingType]];
            this.isShowFAQ = this.verb?.find(x => x.type == 'FAQ')?.verbiage != null;
            this.isShowManual = this.verb?.find(x => x.type == 'Manual')?.verbiage != null;
            this.contextVerbiage = contextVerbiage;
        });
    }

    showDocument(type) {
        const manual = this.verb.find(x => x.type == type)?.verbiage?.userManual;
        if (manual) {
            this.showFile(manual);
        }
    }

    showFile(manual) {
        this.matDialog.open(FileViewerComponent, {
            panelClass: ['sidepanel', 'animate__animated', 'animate__slideInRight'],
            width: '65%',
            height: '100%',
            minWidth: '630px',
            data: {
                fileName: manual.fileName,
                fileId: manual.fileId,
                fileVersion: manual.fileVersion
            }
        });
    }
}
